export default __webpack_public_path__ + "static/Image_3-8fbe87bbedc99e36377f239f9b0398e8.jpg";